<template>
    <section class="info-section">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 text-center">
                    <div class="event-info d-flex align-items-start justify-content-center oswald">
                        <div class="thumb-container"></div>
                        <div class="content">
                            <div class="title h1">
                                {{ event.name }}
                            </div>

                            <div class="subtitle h3 light">
                                <span class="date">{{ formattedDate || event.fecha }}</span> - <span class="time">{{ formattedTime || event.hora }}</span>
                            </div>

                            <div class="subtitle h3 light">
                                {{ event.author }}
                            </div>

                            <div class="subtitle h3 light">
                                {{ event.direccion }}
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-9 text-lg-center mt-3 pb-4">
                    <EventoDescripcion  :event="event"/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    
    import EventoDescripcion from './EventoDescripcion';

    export default{
        props: {
            event: {
                required: true,
                type: Object
            },
            sesion: {
                required: true,
                type: Object
            }
        },
        computed: {
            formattedDate() {
                if (!this.sesion?.session_date) return;
                const date = new Date(this.sesion.session_date);
                return date.toLocaleDateString('es-ES').replace(/\//g, '/');
            },
            formattedTime() {
                if (!this.sesion?.session_date) return "";
                const date = new Date(this.sesion.session_date);
                return date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', hour12: false });
            }
        },
        components: {
            EventoDescripcion
        }
    }
</script>